import Error from "./Error";

class Errors {
  constructor(private readonly _list: Error[] = []) {
  }

  public isEmpty(): boolean {
    return this._list.length === 0;
  }

  public toList(): Error[] {
    return this._list;
  }

  public has(target: string): boolean {
    return !!this._list.find((error: Error) => error.target.value === target);
  }

  public getMessage(target: string): string {
    const error: Error | undefined = this._list.find((error: Error) => error.target.value === target);
    return error ? error.message.value : "";
  }
}

export default Errors;